import { Link } from "react-router-dom";
import { ArrowUpRight, Check, Plus } from "lucide-react";
import { BrokerMark } from "@/components/shared/Primitives";

export const DirectoryRow = ({ broker: b, selected, onCompare }) => (
  <tr className="directory-data-row" data-testid={`directory-row-${b.slug}`}>
    <td>
    <div className="directory-identity">
      <BrokerMark broker={b} size={40} />
      <div className="directory-identity-copy">
        <Link to={`/brokers/${b.slug}`} className="t-h6 directory-broker-name" data-testid={`directory-name-${b.slug}`}>{b.name}</Link>
        <div className="directory-features" data-testid={`directory-features-${b.slug}`}>
          <span>{b.spreadModel}</span>
          {b.swapFree && <span className="directory-feature-blue">Swap-free</span>}
          {b.depositBonus && <span>Bonus</span>}
        </div>
      </div>
    </div>
    </td>
    <td className="directory-regulation" data-testid={`directory-regulation-${b.slug}`}>{b.entities.map((e) => e.regulator).join(" · ")}</td>
    <td className="directory-price" data-testid={`directory-cost-${b.slug}`}>${(b.eurUsdSpread * 10 + b.commission).toFixed(2)}<span className="directory-unit">/lot</span></td>
    <td className="directory-deposit" data-testid={`directory-deposit-${b.slug}`}>${b.minDeposit}</td>
    <td>
    <div className="directory-actions">
      <button onClick={onCompare} aria-pressed={selected} data-on={selected} className="directory-compare" data-testid={`directory-compare-${b.slug}`}>{selected ? <Check size={13} /> : <Plus size={13} />}Compare</button>
      <a href={b.referral} target="_blank" rel="noreferrer sponsored" className="directory-visit" data-testid={`directory-visit-${b.slug}`}>Visit <ArrowUpRight size={14} /></a>
    </div>
    </td>
  </tr>
);